/*
 *
 * ExpiredSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import appEnvRemap from 'Utility/appEnvRemap'

const ExpiredSessionModal = (props) => {
  const handlePrimaryAction = () => {
    const redirectPath = props.pathToRedirect ? props.pathToRedirect : appEnvRemap.REDIRECT_PATH_LOGIN
    window.sessionStorage.removeItem('jwe')
    props.actions.hidePopup()
    window.location = redirectPath
  }

  return (
    <MerchantModal
      title={formattedMessage.title}
      primaryButtonLabel={formattedMessage.primaryButtonLabel}
      primaryAction={handlePrimaryAction}
    />
  )
}

ExpiredSessionModal.propTypes = {
  actions: PropTypes.object.isRequired,
  pathToRedirect: PropTypes.string
}

ExpiredSessionModal.defaultProps = {
  pathToRedirect: null
}

export default ExpiredSessionModal
